import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./Page/Landing";
import AnalyticsPage from "./Page/Analytics";
import Users from "./Page/Users";
import Applicants from "./Page/Applicants";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css"; // Import the CSS file
import PremiumMembers from "./Page/Premium";
import StagedUsers from "./Page/StagedUsers";
import Referral from "./Page/Referral";
import DeleteUser from "./Page/DeleteUser";
import VectorDBCount from "./Page/VectorDBCount";
import DeleteDashboardData from "./Page/DeleteDashboardData";
import Matches from "./Page/Matches";
import Interests from "./Page/Interests";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/users" element={<Users />} />
        <Route path="/stagedUsers" element={<StagedUsers />} />
        <Route path="/premium" element={<Applicants />} />
        <Route path="/referrals" element={<Referral />} />
        <Route path="/premiumMembers" element={<PremiumMembers />} />
        <Route path="/deleteUser" element={<DeleteUser />} />
        <Route path="/deleteDashboardData" element={<DeleteDashboardData />} />
        <Route path="/vectorDBCount" element={<VectorDBCount />} />
        <Route path="/matches" element={<Matches />} />
        <Route path="/interests" element={<Interests />} />

      </Routes>
    </Router>
  );
};

export default App;
